export const translatedData = {
    dashboard: {
        dashboard: 'Dashboard',
        currentLink: 'Dashboard',
        name: '',
        admin: 'Admin',
        shortname: '',
    },
    navigation: {
        dashboardTitle: 'Dashboard',
        sidebarTitle: 'Titles',
        files: 'Files',
        metadata: 'Metadata',
        IMDB: 'IMDB',
        Members: 'Members',
        orderHistory: 'Order History',
        billingDetails: 'Billing Details',
        accountSettings: 'Account Settings',
        profileSetting: 'Profile Settings',
        accountDetails: 'Account Details',
        cloudStorage: 'Cloud Storage',
        logout: 'Logout',
        addTitle: 'Create a New Title',
        addSubTitle: 'Add a name to get started.',
        titleName: 'Title Name',
        titleNamePlaceholder: 'Enter a title name',
        titleContent:
            'Initiate a new workspace to streamline project management, foster collaboration, and centralize resources for enhanced productivity and coordination among team members.',
        back: 'Back',
        createTitle: 'Create Title',
        logoutConfirmation: 'Logout Confirmation',
        logoutcontent:
            'Are you sure you want to log out? Logging out will end your current session.',
        cancel: 'Cancel',
        manageTitle: 'Manage Title',
    },
    mainDashboard: {
        videoProcessed: 'TOTAL VIDEO PROCESSED',
        videoProgress: 'VIDEO IN PROGRESS',
        totalTitles: 'TOTAL NUMBER OF TITLES',
        totalMember: 'TOTAL NUMBER OF MEMBERS',
        averageTime: 'Average Processing Time',
        detectionAccuracy: 'Detection Accuracy Rate',
        totalInvoices: 'TOTAL INVOICES',
        videoProcessing: 'VIDEO PROCESSING FAILED',
        recentUploads: 'Recent Uploads',
        fileName: 'File Name',
        uploadDate: 'Upload Date',
        fileType: 'File Type',
        processingStatus: 'Status',
        processing: 'Processing',
        complete: 'Complete',
        failed: 'Failed',
        noFile: 'No files uploaded yet.',
        uploadFile: 'Upload a file to begin processing.',
        processedVideo: 'Processed Videos',
        processingDate: 'PROCESSING DATE & TIME',
        accuracy: 'DETECTION ACCURACY (%)',
        action: 'Action',
        download: 'Download File',
        members: 'Members',
        title: 'Title',
        emailId: 'Email ID',
        joiningDate: 'Joining Date',
        role: 'Role',
        noMember: 'No members added yet.',
        addMember: 'Click “Add New Member” to get started.',
        newTitle: 'Create New Title',
        delete: 'Delete',
    },
    title: {
        speaker: 'Speaker',
        nonSpeach: 'Non Speech',
        upperCase: 'Upper Case',
        lowerCase: 'Lower Case',
        selectaddPunctuation: 'Select Punctuation',
        Selecttense: 'Select Tense',
        addPunctuation: 'Add Punctuation',
        removePunctuation: 'Remove Punctuation',
        presentTense: 'Present Tense',
        participleTense: 'Present Participle Tense',
        normal: 'Letter Case',
        speakerP: 'Select Speaker symbols',
        dialogueP: 'Select Dialogue symbols',
        totalFile: 'TOTAL FILES:',
        uploadVideo: 'Upload New Video',
        refund: 'Refund',
        all: 'All',
        completed: 'Completed',
        failed: 'Failed',
        srt: 'OCR',
        sdh: 'SDH',
        ad: 'AD',
        failed_srt: 'SRT Failed',
        failed_upload: 'Upload Failed',
        retry: 'Retry',
        refundInvoice: 'Refund Invoice',
        processing: 'Processing',
        name: 'File Name',
        fileType: 'File Type',
        price: 'PRICE',
        uploadBy: 'Uploaded By',
        date: 'Date',
        storage: 'Storage (MB)',
        status: 'Status',
        action: 'Action',
        downloadSrt: 'Download srt',
        downloadAudio: 'Download Video',
        editSRT: 'Edit SRT',
        newEditSRT: 'Edit SRT',
        dialogSheetEdit: 'Dialog Sheet Editor',
        delete: 'Delete',
        uploadFirst: 'Upload your First Video',
        uploadFirstContent: `Now that you have given workspace a little it's time to convert your video projects
      to .srt file. Upload your first video and leave the rest on us. Click the button below to upload 
      your video and let's begin the process.`,
        deleteConfirmation: 'Delete Title',
        deleteContent:
            'This action cannot be undone. Are you sure you want to delete this title?',
        cancel: 'Cancel',
        confirm: 'Delete',
        placeholder: 'Search',
        searchPlaceholder: 'Search by character name',
        imdbPlaceholder: 'Paste IMDB URL',
        title: 'Manage Titles',
        titleContent: 'Delete your titles.',
        createdBy: 'Created By',
        createdOn: 'Created On',
        orderHistory: 'Order History',
        billingDetails: 'Billing Details',
        accountSettings: 'Account Settings',
        profileSetting: 'Profile Settings',
        manageTitle: 'Manage Title',
        manageTitleContent: 'Add, remove, search for, and manage your titles',
        accountDetails: 'Account Details',
        //not sure if the below is still needed?
        accountDetailsContent:
            'Securely manage and update your cloud credentials for access to cloud services.',
        cloudStorage: 'Cloud Storage',
    },
    member: {
        memberOf: 'Members of',
        totalMember: 'members',
        addNewMember: '+ Add New Member',
        memberName: 'Member Name',
        emailId: 'Email',
        contactNumber: 'Contact Number',
        joiningDate: 'Joining Date',
        role: 'Role',
        action: 'Action',
        administrator: 'Admin',
        viewer: 'Viewer',
        noMember: 'No members added yet.',
        addMember: 'Click “Add New Member” to get started.',
        inviteNewMember: 'Add Member',
        inviteNewMemberSubtitle: 'Invite a new member to this title.',
        emailInvitation: 'Email Address',
        emailP: 'Enter email address',
        emailR: 'Email is required',
        emailI: 'Invalid email format',
        inviteContent:
            'We’ll send an invitation link to this address. The user will log in to accept the invite.',
        userrole: 'User Role',
        roleR: 'User role is required',
        endContent:
            'The administrator has access to all numbers within the company and can change their settings. The administrator can buy new numbers and change company settings.',
        back: 'Back',
        sendInvite: 'Send Invite',
        deleteConfirmation: 'Delete Member',
        deleteMessage:
            'This action cannot be undone. Are you sure you want to delete this member?',
        confirm: 'Delete',
        cancel: 'Cancel',
    },
    orderHistory: {
        order: 'Order History',
        totalOrder: 'orders',
        uploadNewVideo: 'Upload New Video',
        from: 'From',
        fromP: 'Search by File Name/ File Type',
        to: 'To',
        resetDate: 'Reset Date',
        refrence: 'Reference',
        orderNumber: 'Order Number',
        orderDate: 'Order Date',
        orderPlaced: 'Placed By',
        videoLength: 'Length',
        cost: 'Cost',
        status: 'Status',
        action: 'Action',
        minutes: 'Minutes',
        processing: 'Processing',
        complete: 'Completed',
        viewOrder: 'View order details',
        noOrder: 'No Orders Placed. Start Uploading video',
        printReciept: 'Print Receipt',
        orderP: 'Order Placed',
        totalCost: 'Total Cost',
        fileName: 'File Name',
        originalDocuments: 'Original Documents',
    },
    billing: {
        manageBilling: 'Manage Billing',
        titleContent:
            'Effortlessly manage payments and view billing details for video conversion service',
        paymentId: 'Payment ID',
        refrenceId: 'Reference ID',
        dateTransaction: 'Date Of Transction',
        orderPlacedBy: 'Order Place By',
        totalvideoes: 'Total Videos',
        totalCost: 'Total Cost',
        action: 'Action',
        view: 'View',
        noRecords: 'No Records Found',
        detailBillingContent: 'Billing details for the selected transaction ID',
        printReciept: 'Print Receipt',
        orderPlaced: 'Order Date',
        fileName: 'File Name',
        originalDocuments: 'Original Documents',
        videoLength: 'Length',
        cost: 'Cost',
        minutes: 'Minutes',
        paymentMethod: 'Payment Method',
        detailsPayment: 'Details of payment method used to make the payment',
        card: ' ending in ',
    },
    profile: {
        profileSetting: 'Profile Settings',
        editDetails: 'Edit Details',
        profileContent: 'Update your personal information such as name, email.',
        firstName: 'First Name',
        firstNameP: 'John',
        firstNameR: ' First Name is required.',
        lastName: 'Last Name',
        lastNameP: 'Deo',
        lastNameR: ' Last Name is required.',
        companyName: 'Company Name',
        companyNameP: 'Enter your company name',
        companyNameR: 'Company Name is required.',
        companyAddress: 'Company Address',
        companyAddressP: 'Enter Address',
        companyAddressR: 'Company Address is required.',
        companyVat: 'Company VAT Number',
        companyVatP: 'Enter VAT Number',
        companyVatR: 'Company VAT Number is required.',
        phoneNumber: 'Phone Number',
        phoneNumberP: 'Enter phone number',
        phoneNumberR: 'Phone Number is required.',
        emailId: 'Your Email ID',
        cancel: 'Cancel',
        saveChange: 'Save changes',
        update: 'Update',
        orderHistory: 'Order History',
        billingDetails: 'Billing Details',
        accountSettings: 'Account Settings',
        accountDetails: 'Account Detail',
        cloudStorage: 'Cloud Storage',
        manageTitle: 'Manage Title',
    },
    account: {
        accountDetails: 'Account Details',
        accountContent: 'Add, remove, or activate your payment methods',
        addNewCard: 'Add New Card',
        paymentMethod: 'Payment Method',
        ending: 'ending in ',
        deleteCard: 'Delete Card',
        activatedCard: ' Activated Card',
        inActivatedCard: 'Deactivate',
        availableSoon: 'Available Soon',
        content: 'Enter the details of the new card',
        cardP: 'Enter your card number',
        billingAddress: 'Card details',
        firstName: 'First Name',
        firstNameP: 'Enter your first name',
        firstNameR: 'First Name is required.',
        lastName: 'Last Name',
        lastNameP: 'Enter your last name',
        lastNameR: 'Last Name is required.',
        email: 'Email',
        emailP: 'Enter your Email',
        emailR: ' Email is required.',
        phoneNumber: 'Phone Number',
        phoneNumberP: 'Enter phone number',
        phoneNumberR: ' Phone Number is required.',
        address1: 'Address line 1',
        address1P: 'Enter Address',
        address1R: ' Address line 1 is required.',
        address2: 'Address line 2 (Optional)',
        city: 'Town/City',
        cityP: 'Enter city',
        cityR: ' Town/City is required.',
        state: 'State / province / county (optional)',
        stateP: 'Enter state/ province/ country',
        postcode: 'Postcode',
        postcodeP: 'Enter Postcode',
        postcodeR: 'Postcode is required.',
        country: 'Country',
        countryS: 'Select a country',
        countryR: ' Country is required.',
        cancel: 'Cancel',
        loading: ' Loading...',
        save: 'Save',

        deleteConfirmation: 'Delete Confirmation!',
        deleteContent: 'Are you sure you want to Delete?',
        confirm: 'Confirm',
        orderHistory: 'Order History',
        billingDetails: 'Billing Details',
        accountSettings: 'Account Settings',
        profileSetting: 'Profile Settings',
        cloudStorage: 'Cloud Storage',
        manageTitle: 'Manage Title',
    },
    cloud: {
        cloudStorage: 'Cloud Storage',
        awsCredentials: 'AWS Credentials',
        gcp: 'GCP',
        editDetails: 'Edit Details',
        cloudContent:
            'Securely manage and update your cloud credentials for seamless access to cloud services.',
        accessKey: 'Access Key ID',
        accessKeyP: 'Enter Access Key',
        accessKeyR: 'Access Key ID is required.',
        secretAccessKey: 'Secret Access key',
        secretAccessKeyP: 'Enter secret access key',
        secretAccessKeyR: 'Secret Access key is required.',
        region: 'Region',
        regionP: 'Enter region',
        regionR: ' Region is required.',
        cancel: 'Cancel',
        saveChanges: 'Save changes',
        uploadFile: 'Upload File',
        status: 'Status*',
        orderHistory: 'Order History',
        billingDetails: 'Billing Details',
        accountSettings: 'Account Settings',
        profileSetting: 'Profile Settings',
        manageTitle: 'Manage Title',
        accountDetails: 'Account Details',
    },
    videos: {
        noData: 'No videos uploaded yet.',
        uploadData: 'Your uploaded videos will appear here.',
        videos: 'Videos',
        upload: 'Upload',
        uploadVideoFile: 'Upload Videos',
        videoSize: '(Up to 20 files, max size 3GB each.)',
        uploadVideo: 'Upload from Device',
        uploadUrl: 'Upload using URLs',
        uploadCloud: 'Upload from Cloud',
        youCan: 'You can upload video',
        youcanContent: 'Click to upload',
        youcanContentTwo: 'or drag and drop',
        youcanContentThree: 'Up to 20 files, max size 3GB each.',
        delete: 'Delete',
        newUrl: 'Add another URL',
        loading: 'Loading...',
        submit: 'Continue',
        allBucket: 'All Bucket',
        selectAccount: 'Select Account',
        awsAccount: 'AWS Account',
        gcpAccount: 'GCP Account',
        fileName: 'File Name',
        uploadDate: 'UPLOAD DATE & TIME',
        videosize: 'Size',
        videoLength: 'Length',
        cost: 'Cost',
        action: 'Action',
        minutes: 'minutes',
        totalCost: 'TOTAL COST',
        imdbUrlLabel: 'imdb Url',
        // openToClose: 'Open to close (€0.23 per minute)',
        openToClose: 'Subtitle Extractor (€0.23 per minute)',
        dialogSheet: 'Dialogue Sheets (€0.23 per minute)',
        // automatedCaptions: 'Automated captions (€0.46 per minute)',
        automatedCaptions:
            'Hearing Impaired Subtitles (Coming Soon)  (€0.46 per minute)',
        // audioDescription: 'Audio description (€4.6 per minute)',
        audioDescription:
            'Audio Description Stereo Track (Coming Soon) (€4.6 per minute)',
        // ponytail: €0.23 is a PLACEHOLDER price (mirrors the built subtitle/dialogue tier) —
        // set the real ASD rate here and in uploadvideo.component.ts `p5`.
        activeSpeakerDetection: 'Active Speaker Detection (€0.23 per minute)',

        continueExsiting: 'Use existing payment method',
        cancel: 'Cancel',
        makePayment: 'Make Payment',
        content: 'Enter the details of the new card',
        cardP: 'Enter your card number',
        billingAddress: 'Billing Address',
        firstName: 'First Name',
        firstNameP: 'Enter your first name',
        firstNameR: 'First Name is required.',
        lastName: 'Last Name',
        lastNameP: 'Enter your last name',
        lastNameR: 'Last Name is required.',
        email: 'Email',
        emailP: 'Enter your Email',
        emailR: ' Email is required.',
        phoneNumber: 'Phone Number',
        phoneNumberP: 'Enter phone number',
        phoneNumberR: ' Phone Number is required.',
        address1: 'Address line 1',
        address1P: 'Enter Address',
        address1R: ' Address line 1 is required.',
        address2: 'Address line 2 (Optional)',
        city: 'Town/City',
        cityP: 'Enter city',
        cityR: ' Town/City is required.',
        state: 'State / province / county (optional)',
        stateP: 'Enter state/ province/ country',
        postcode: 'Postcode',
        postcodeP: 'Enter Postcode',
        postcodeR: 'Postcode is required.',
        country: 'Country',
        countryS: 'Select a country',
        countryR: ' Country is required.',
        addNewCard: 'Add New Card',
        save: 'Save',
        addMetadata: 'Add Metadata',
        update: 'Update',
        metaContent: 'Enter character details to create a new metadata entry.',
        inputNumber: 'Number of Entries:',
        name: 'Name',
        nameP: 'Enter name',
        uploadImage: 'Upload Image',
        urlPaste: 'Paste your video URL Here',
        postcodeMinLength: 'Zip code must be at least 3 characters',
        postcodeMaxLength: 'Zip code cannot exceed 10 charactersium',
        phoneNumberPattern: 'Phone number must contain only numbers',
        phoneNumberMinLength: 'Phone number must be at least 7 digits',
        phoneNumberMaxLength: 'Phone number cannot exceed 15 digits',
    },
    metadata: {
        title: 'Metadata Manager',
        titleContent: 'Add, edit, or delete metadata linked to this title.',
        uploadNewMetadata: 'Add New Metadata',
        characterName: 'Character Name',
        actorName: 'Actor Name',
        image: 'Image',
        speaker: 'Speaker',
        action: 'Action',
        noData: 'No metadata found.',
        uploadData: 'Add a new entry to get started.',
        submit: 'Search',
        submitMetadata: 'Add Metadata',
        confirm: 'Delete',
        deleteConfirmation: 'Delete Metadata',
        deleteContent:
            'This action cannot be undone. Are you sure you want to delete this entry?',
    },
};
